import { useSearchParams } from "react-router";

import CompanyLogo from "~/components/CompanyLogo";

const RocketRentLogo = () => {
  const [searchParams] = useSearchParams();

  const clean = searchParams.get("view") === "clean";

  if (clean) return null;

  return (
    <div className="flex justify-center sm:mx-auto sm:w-full sm:max-w-md">
      <CompanyLogo />
    </div>
  );
};

export default RocketRentLogo;
